/** @format */

import { useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'src/hooks/use-auth';
import { checkRoleAcceptAccessPage } from 'src/utils/check-role-accept-access-page';
import { MobileNav } from '../mobile-nav';
import { TopNav } from './top-nav';
import { useMobileNav } from './use-mobile-nav';

import Error401Page from 'src/pages/401';
// import Error404Page from "src/pages/404";

const NormalLayoutRoot = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  maxWidth: '100%'
});

const NormalLayoutContainer = styled('div')({
  display: 'flex',
  flex: '1 1 auto',
  flexDirection: 'column',
  width: '100%'
});

export const NormalLayout = (props) => {
  const {
    user: { permissions }
  } = useAuth();
  const { children, navColor, sections } = props;
  const location = useLocation();
  const currentPath = location.pathname;
  // const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));
  const mdUp = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const mobileNav = useMobileNav();

  const checkAcceptAccess = checkRoleAcceptAccessPage(currentPath, permissions.access);
  // console.log("NormalLayoutContainer", checkAcceptAccess);
  return (
    <>
      <TopNav color={navColor} onMobileNav={mobileNav.handleOpen} sections={sections} />
      {!mdUp && <MobileNav color={navColor} onClose={mobileNav.handleClose} open={mobileNav.open} sections={sections} />}
      {checkAcceptAccess ? (
        <NormalLayoutRoot>
          <NormalLayoutContainer>{children}</NormalLayoutContainer>
        </NormalLayoutRoot>
      ) : (
        <Error401Page />
      )}
    </>
  );
};

NormalLayout.propTypes = {
  children: PropTypes.node,
  navColor: PropTypes.oneOf(['blend-in', 'discreet', 'evident']),
  sections: PropTypes.array
};
